import { useState } from "react";
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";
import { PiDotsThreeOutlineVerticalFill } from "react-icons/pi";
import { useLocation, useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { getApi, postApi } from "../Admin Master/Area Control/Zonemaster/ServicesApi";



function ViewBill({ switchToInvoice }) {
    const navigate = useNavigate();
    const location = useLocation();

    const [invoice, setInvoice] = useState([])
    const [openRow, setOpenRow] = useState(null);
    const [loading, setLoading] = useState(false);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const handleFormChange = (value, key) => {
        setFormData({ ...formData, [key]: value })
    }
    const indexOfLastRow = currentPage * rowsPerPage;
    const indexOfFirstRow = indexOfLastRow - rowsPerPage;
    const currentRows = invoice.slice(indexOfFirstRow, indexOfLastRow);
    const totalPages = Math.ceil(invoice.length / rowsPerPage);
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const [formData, setFormData] = useState({
        fromDate: firstDayOfMonth,
        toDate: today,
        invoiceNo: "",
    });

    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const queryParams = new URLSearchParams({
                InvoiceNo: formData.invoiceNo || "",
                FromDate: formData.fromDate
                    ? formData.fromDate.toISOString().split("T")[0]
                    : "",
                ToDate: formData.toDate
                    ? formData.toDate.toISOString().split("T")[0]
                    : "",
            });

            const response = await getApi(
                `/SearchFutureInvoice?${queryParams.toString()}`
            );

            console.log(response);

            if (response?.status === 1) {
                setInvoice(response.data || []);
            } else {
                setInvoice([]);
                Swal.fire("Info", response?.message || "No Invoice Found", "info");
            }
        } catch (err) {
            console.error(err);
            setInvoice([]);
            Swal.fire("Error", "Failed to fetch invoices", "error");
        }
    };
    const handleDelete = async (invoiceNo) => {
        const result = await Swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
        });

        if (!result.isConfirmed) return;

        try {
            const response = await postApi(
                `/DeleteFutureInvoice?InvoiceNo=${encodeURIComponent(invoiceNo)}`
            );

            if (response.status === 1) {
                Swal.fire(
                    "Deleted!",
                    response.message,
                    "success"
                );

                // Refresh data
                handleSubmit({ preventDefault: () => { } });

                // OR remove locally
                // setInvoice(prev => prev.filter(item => item.InvoiceNo !== invoiceNo));
            } else {
                Swal.fire("Error", response.message, "error");
            }
        } catch (error) {
            console.error(error);
            Swal.fire("Error", "Failed to delete invoice.", "error");
        }
    };


    /**************** function to export table data in excel and pdf ************/
    // Handle changing page
    const handleRowsPerPageChange = (event) => {
        setRowsPerPage(Number(event.target.value));
        setCurrentPage(1);
    };
    const handlePreviousPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleOpenInvoicePrint = (invNo) => {
        navigate("/futureinvoicepdf", { state: { invoiceNo: invNo, from: location.pathname, tab: "ViewBill" } })
    };

    return (
        <>

            <div className="body">
                <div className="container1">
                    <form onSubmit={handleSubmit}>
                        <div className="fields2">
                            <div className="input-field3">
                                <label htmlFor="">Invoice No</label>
                                <input type="text" placeholder="Invoice No"
                                    className="input" value={formData.invoiceNo} onChange={(e) => handleFormChange(e.target.value, "invoiceNo")} />
                            </div>
                            <div className="input-field3">
                                <label htmlFor="">From Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.fromDate}
                                    onChange={(date) => handleFormChange(date, "fromDate")}
                                    dateFormat="dd/MM/yyyy"
                                    className="form-control form-control-sm"
                                />
                            </div>

                            <div className="input-field3">
                                <label htmlFor="">To Date</label>
                                <DatePicker
                                    portalId="root-portal"
                                    selected={formData.toDate}
                                    onChange={(date) => handleFormChange(date, "toDate")}
                                    dateFormat="dd/MM/yyyy"

                                />
                            </div>
                            <div className="bottom-buttons" style={{ marginTop: "20px", marginLeft: "10px" }}>
                                <button className="ok-btn" style={{ height: "35px" }} type="submit">Submit</button>
                            </div>



                        </div>
                    </form>

                    {loading ? (<div className="loader"></div>) : (
                        <div className='table-container' style={{ margin: "0px" }}>
                            <table className='table table-bordered table-sm' style={{ whiteSpace: "nowrap" }}>
                                <thead className='table-sm'>
                                    <tr>
                                        <th className="w-60">Actions</th>
                                        <th className="w-60">Sr.No</th>
                                        <th className="w-100">Invoice No</th>
                                        <th className="w-100">Invoice Date</th>
                                        <th className="w-100">Due Date</th>
                                        <th>Customer Name</th>
                                        <th>Total Qty</th>
                                        <th>Total Amount</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {currentRows.map((row, index) => (
                                        <tr key={index} style={{ fontSize: "12px", position: "relative" }}>
                                            <td className="w-60"><PiDotsThreeOutlineVerticalFill
                                                style={{ fontSize: "20px", cursor: "pointer" }}
                                                onClick={() =>
                                                    setOpenRow(openRow === index ? null : index) // toggle only this row
                                                }
                                            />

                                                {openRow === index && (
                                                    <div
                                                        style={{
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            flexDirection: "row",
                                                            position: "absolute",
                                                            alignItems: "center",
                                                            left: "70px",
                                                            top: "1px",
                                                            borderRadius: "10px",
                                                            backgroundColor: "white",
                                                            zIndex: "999999",
                                                            height: "24px",
                                                            width: "100px",
                                                            padding: "10px",
                                                        }}
                                                    >
                                                        <button className='edit-btn' onClick={() => handleOpenInvoicePrint(row.InvoiceNo)}>
                                                            <i className='bi bi-file-earmark-pdf-fill' ></i>
                                                        </button>
                                                        <button onClick={() => {
                                                            setOpenRow(null);
                                                            handleDelete(row.InvoiceNo)
                                                        }
                                                        } className='edit-btn'>
                                                            <i className='bi bi-trash' ></i>
                                                        </button>
                                                    </div>
                                                )}</td>
                                            <td className="w-60">{index + 1}</td>
                                            
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-link p-0"
                                                    style={{ fontSize: "14px", fontWeight: "bold", color: "#055a0f" }}

                                                    onClick={() => switchToInvoice(row.InvoiceNo)}

                                                >
                                                    {row.InvoiceNo}

                                                </button>
                                            </td>


                                            <td>{row.InvoiceDate}</td>
                                            <td>{row.DueDate}</td>
                                            <td>{row.Customer_Name}</td>
                                            <td>{row.Qty}</td>
                                            <td>{row.Amount}</td>

                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div >)
                    }

                    <div className="row" style={{ whiteSpace: "nowrap" }}>
                        <div className="pagination col-12 col-md-6 d-flex justify-content-center align-items-center mb-2 mb-md-0">
                            <button className="ok-btn" onClick={handlePreviousPage} disabled={currentPage === 1}>
                                {'<'}
                            </button>
                            <span style={{ color: "#333", padding: "5px" }}>
                                Page {currentPage} of {totalPages}
                            </span>
                            <button className="ok-btn" onClick={handleNextPage} disabled={currentPage === totalPages}>
                                {'>'}
                            </button>
                        </div>

                        <div className="rows-per-page col-12 col-md-6 d-flex justify-content-center justify-content-md-end align-items-center">
                            <span htmlFor="rowsPerPage" className="me-2">Rows per page: </span>
                            <select
                                id="rowsPerPage"
                                value={rowsPerPage}
                                onChange={(e) => {
                                    setRowsPerPage(Number(e.target.value));
                                    setCurrentPage(1);
                                }}

                                style={{ height: "40px", width: "50px", border: "1.5px solid #002357" }}
                            >
                                <option value={5}>5</option>
                                <option value={10}>10</option>
                                <option value={25}>25</option>
                                <option value={50}>50</option>
                                <option value={100}>100</option>
                                <option value={200}>200</option>
                                <option value={500}>500</option>
                            </select>
                        </div>
                    </div>
                </div >
            </div >

        </>
    );
};

export default ViewBill;